import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Kentucky Invoice": {
    parameters: {
      linkUrls: ["https://kentucky.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Credential",
    state: "KY",
  },
  "Kentucky State Portal": {
    parameters: {
      linkUrls: ["https://kentucky.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "KY",
  },
};
